import React, { useRef, useState, useContext, useEffect } from "react";
import CanvasDraw from "react-canvas-draw";
import "../App.css";
import CardUploadImage from "./CardUploadImage";
import Context from "../Context";
import Localbase from "localbase";

let db = new Localbase("db");

const CardsEvaluacion = ({
  urlImage,
  title,
  text1,
  text2,
  text3,
  text4,
  text5,
  text6,
  htmlFor,
  idDraw,
}) => {
  const { showIcons } = useContext(Context);

  const Draw = useRef(null);

  // Get image from indexeddb to state imgPreview with lib Localbase

  useEffect(() => {
    /* const canvas = Draw.current;
const dataURL =  canvas.toDataURL(); */
    /* console.log('dataURL', dataURL);
     */
    db.collection("CardsDraw")
      .doc(idDraw)
      .get()
      .then((document) => {
        document && Draw.current.loadSaveData(document.image, false);
      });
  });

  const [backgroundImage, setBackgroundImage] = useState(
    `../assets/images/${urlImage}`
  );

  /* const handleSave = () => {
   
    const data = Draw.current.getSaveData();
    
    // create a collection ( 'CardsPhotos' ) and  document ( htmlFor ) with Localbase
    db.collection("CardsDraw").add(
      {
        image: data,
      },
      idDraw
    );
  
  }; */

  const handleChange = () => {
    const data = Draw.current.getSaveData();
    const testIMG = Draw.current.canvasContainer.children[1].toDataURL()

    console.log('testIMG', testIMG )

    // create a collection ( 'CardsPhotos' ) and  document ( htmlFor ) with Localbase
    db.collection("CardsDraw").add(
      {
        image: data,
        testIMG: testIMG
      },
      idDraw
    );
    
  };

  const handleClear = () => {
    db.collection("CardsDraw").doc(idDraw).delete();

    Draw.current.clear();
  };

  const handleBack = () => {
    Draw.current.undo();
  };

  const styleCanvas = {
    border: "3px solid #ff7d02",
    boxSizing: "border-box",
    boxShadow: "0px 4px 50px rgba(0, 0, 0, 0.25)",
    borderRadius: "30px",
    backgroundColor: "#FEFBF4",
  };

  return (
    <>
      <div className="wraper-cards">
        <div className="container-info">
          <h3>{title}</h3>
          <br></br>
          <br></br>

          <p>
            <h4>{text1}</h4>
            <br></br>
            <h4>{text2}</h4>
            <h4>{text3}</h4>
            <h4> {text4}</h4>
            <h4> {text5}</h4>
            <h4>{text6}</h4>
            <h4></h4>
            <h4></h4>
          </p>
        </div>
        {/*  */}

        {/* 2 card */}

        <div className="card-upload-image">
          <CardUploadImage htmlFor={htmlFor} />
        </div>

        {/* 3 card */}

        <div className="card-canvas-image">
          <CanvasDraw
            lazyRadius={0}
            brushRadius={2}
            canvasWidth={"339px"}
            canvasHeight={"486px"}
            imgSrc={backgroundImage}
            hideGrid={true}
            ref={Draw}
            style={styleCanvas}
            onChange={handleChange}
          />

          {showIcons && (
            <div className="icons-card-canvas">
              <img
                className="icon-trash-canvas"
                src="/assets/images/icon-undo.png"
                alt="icon-image"
                onClick={handleBack}
              />
              <img
                className="icon-trash-canvas"
                src="/assets/images/trash.png"
                alt="icon-image"
                onClick={handleClear}
              />
              {/*  <img
                className="icon-trash-canvas"
                src="/assets/images/icon-download.png"
                alt="icon-image"
                onClick={handleSave}
              /> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CardsEvaluacion;
